import { Directive, ElementRef } from '@angular/core';
import { AppConfig } from '../../../app/config/app-config';

@Directive({
    selector: '[appContactCap]',
})
export class ContactCapDirective {
    constructor(el: ElementRef) {
        if (el.nativeElement instanceof HTMLAnchorElement) {
            const anchorElement = el.nativeElement as HTMLAnchorElement;
            anchorElement.href = AppConfig.settings.capContactUrl;
            anchorElement.target = '_blank';
        }
    }
}
